import { Popup } from '../../../../../components/Popup'
import { Button, BUTTON_TYPES } from '../../../../../components/Button'
import { BTN_TXT, LABELS, PLACEHOLDERS } from '../../../../../constants'
import { ability, ACTIONS, SUBJECTS } from '../../../../Permission'
import { FieldWithLabel } from '../../../../../components/FieldWithLabel/FieldWithLabel'
import { LeadByIndicator } from '../../../../../components/LeadByIndicator'
import { LED_BY_VALUE } from '../../../../../components/LeadByIndicator/constants'
import Typography from '../../../../../components/Typography/Typography'
import { ReactComponent as Plus16 } from 'assets/svg/Plus16.svg'
import { ReactComponent as EditIcon } from 'assets/svg/EditBlue16.svg'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { THandleGpoProps } from './types'
import { setLoading } from '../../../../../redux/store/common/slice'
import { useDispatch } from 'react-redux'

import { TOption } from '../../../../../components/Select/types'
import { Select } from '../../../../../components/Select'
import 'components/Checkbox/checkbox.default.scss'

import { getGpoList } from '../../../Gpo/api'
import { updateCommunityInfo } from '../../../api'

const HandleGpo = ({
  gpoData,
  getDetails,
  isCommunity,
  communityId
}: THandleGpoProps) => {
  const dispatch = useDispatch()

  const [gpo, setGpo] = useState<string | null>(null)
  const [showPopup, setShowPopup] = useState<boolean>(false)
  const [gpoList, setGpoList] = useState<TOption[]>([])

  const onCloseModal = () => setShowPopup(false)
  const onOpenModal = () => {
    setGpo(gpoData?.gpo?.uuid || null)
    setShowPopup(true)
  }

  const canManageGpo = useMemo(
    () => ability.can(ACTIONS.MANAGE, SUBJECTS.GPO_COMMUNITY),
    []
  )
  const canSeeGpo = useMemo(
    () => ability.can(ACTIONS.VIEW, SUBJECTS.GPO_COMMUNITY),
    []
  )

  const fetchGpoList = async () => {
    await getGpoList({}).then((res) => {
      setGpoList(
        res.data.results.map((option) => ({
          label: option.name,
          value: option.uuid
        }))
      )
    })
  }

  useEffect(() => {
    fetchGpoList()
  }, [])

  const onSubmitGpo = useCallback(
    async (value) => {
      dispatch(setLoading(true))
      try {
        if (isCommunity) {
          if (!communityId) return
          await updateCommunityInfo(
            {
              gpo: { uuid: value }
            },
            communityId
          )
        }
        getDetails()
      } catch (err) {
        console.error(err)
      } finally {
        onCloseModal()
        setGpo('')
        dispatch(setLoading(false))
      }
    },
    [communityId, dispatch, getDetails, isCommunity]
  )
  return (
    <>
      {canSeeGpo && !!gpoData?.gpo?.name ? (
        <div className="row space-between national-gpo-wrapper">
          <FieldWithLabel title={LABELS.GPO} className="gpo-field">
            <div className="row gap-8">
              <LeadByIndicator value={LED_BY_VALUE.NATIONAL_GPO} />
              <Typography.Body1>{gpoData?.gpo?.name}</Typography.Body1>
            </div>
          </FieldWithLabel>
          {canManageGpo && (
            <div className="gpo-edit-icon" onClick={onOpenModal}>
              <EditIcon />
            </div>
          )}
        </div>
      ) : canManageGpo ? (
        <FieldWithLabel title={LABELS.GPO} className="gpo-field">
          <Button
            className="contract-categories__add-btn"
            onClick={onOpenModal}
            type={BUTTON_TYPES.GHOST}
            icon={<Plus16 />}
            upperCase
            medium
          >
            {BTN_TXT.ADD_GPO}
          </Button>
        </FieldWithLabel>
      ) : null}
      {showPopup && (
        <Popup
          title={`${!gpoData?.gpo?.name ? 'Add' : 'Edit'} GPO`}
          className="contract-categories__categories-popup"
          visible={showPopup}
          onCancel={onCloseModal}
          footer={
            <>
              <Button
                onClick={onCloseModal}
                type={BUTTON_TYPES.DEFAULT}
                upperCase
              >
                {BTN_TXT.CANCEL}
              </Button>
              <Button
                type={BUTTON_TYPES.PRIMARY}
                disabled={!gpo}
                onClick={() => onSubmitGpo(gpo)}
                upperCase
              >
                {BTN_TXT.SAVE}
              </Button>
            </>
          }
        >
          <Select
            options={gpoList}
            className="long-select"
            propsItem={{
              label: LABELS.GPO
            }}
            propsSelect={{
              required: true,
              value: gpo,
              placeholder: PLACEHOLDERS.PLEASE_SELECT,
              onChange: (val) => setGpo(val)
            }}
          />
        </Popup>
      )}
    </>
  )
}

export default HandleGpo
